<template>
  <b-modal size="lg" id="modal-integration-hotmart" hide-footer>
    <div class="allContentModal">

      <div class="spaceText1">
        <div class="logo">
          <svg xmlns="http://www.w3.org/2000/svg" class="logo-svg" viewBox="0 0 1003.08 321.74">
            <title>hotmart-42</title>
            <path
              d="M287.06,603.64V458.7a1.23,1.23,0,0,1,1.3-1.3h27.89a1.4,1.4,0,0,1,1.31,1.3v52.4h.52c7.3-9.38,18.5-13.56,30.76-13.56,21.89,0,28.93,14.34,28.93,33.37v73a1.39,1.39,0,0,1-1.3,1.3H348.58a1.23,1.23,0,0,1-1.31-1.3V533.52c0-8.34-8.6-10.69-14.07-10.69s-15.64,3.65-15.64,13.82v67a1.4,1.4,0,0,1-1.31,1.3H288.36a1.39,1.39,0,0,1-1.3-1.3ZM509.41,575V525.18H496.64a1.24,1.24,0,0,1-1.31-1.31v-18c0-.53.53-1.05.79-1.31.52-.26,16.94-4.95,16.94-4.95s8.86-28.15,9.12-28.67a1.22,1.22,0,0,1,1.31-.79h15.12a1.24,1.24,0,0,1,1.3,1.31v28.15h22.42a1.39,1.39,0,0,1,1.3,1.3v22.94a1.4,1.4,0,0,1-1.3,1.31H539.91V572.1c0,4.95,2.87,7.82,9.38,7.82h13a1.39,1.39,0,0,1,1.3,1.3v20.07a1.62,1.62,0,0,1-.78,1.31c-7.82,2.86-12.25,4.69-21.38,4.69C518.8,607,509.41,593.73,509.41,575Zm436.37,0V525.18H933a1.24,1.24,0,0,1-1.31-1.31v-18a2.17,2.17,0,0,1,.79-1.31c.52-.26,16.94-4.95,16.94-4.95s8.86-28.15,9.12-28.67a1.2,1.2,0,0,1,1.31-.79H975a1.24,1.24,0,0,1,1.3,1.31v28.15H998.7a1.39,1.39,0,0,1,1.3,1.3v22.94a1.4,1.4,0,0,1-1.3,1.31H976.28V572.1c0,4.95,2.87,7.82,9.38,7.82h13a1.39,1.39,0,0,1,1.3,1.3v20.07a1.62,1.62,0,0,1-.78,1.31c-7.82,2.86-12.25,4.69-21.38,4.69C954.9,607,945.78,593.73,945.78,575ZM582.14,603.64v-103a1.23,1.23,0,0,1,1.3-1.3h25.29a1.73,1.73,0,0,1,1.3,1c0,.52,2.87,10.43,2.87,10.43h.52c7.3-9.39,18.25-13.56,30.5-13.56,14.86,0,22.16,6.78,26.33,17.21H671c7.56-12.77,20.85-17.21,33.1-17.21,21.9,0,28.94,14.34,28.94,33.37v73a1.23,1.23,0,0,1-1.3,1.3h-27.9a1.39,1.39,0,0,1-1.3-1.3V533.78c0-8.34-7.82-11.47-13.29-11.47-6.26,0-15.9,3.91-16.17,13.29v67.78a1.39,1.39,0,0,1-1.3,1.3H643.66a1.23,1.23,0,0,1-1.3-1.3V533.52c0-8.34-8.35-11.47-14.34-11.47-5.48,0-15.12,4.17-15.12,14.6v66.73a1.23,1.23,0,0,1-1.3,1.3H583.7a1.17,1.17,0,0,1-1.56-1Zm169.18-80.81v-19a1.19,1.19,0,0,1,1-1.3c14.6-2.87,27.89-5,40.66-5,27.11,0,42.76,6.52,42.76,35.72V603.9a1.24,1.24,0,0,1-1.31,1.3H807.88c-.78,0-1-.52-1.3-1s-2.87-10.43-2.87-10.43H805c-7.56,10.43-17.73,13.56-30,13.56-19.81,0-30.5-15.38-30.5-33.63,0-27.37,20.07-32.84,34.93-32.84h25.81v-7c0-8.6-6.52-10.43-31-10.43-10.43,0-21.38.78-21.9.78a1.83,1.83,0,0,1-1-1.3Zm54.22,36.49H788.85c-8.86,0-14.59,3.39-14.59,12.78,0,10.16,7.3,12.51,14.33,12.51,6.52,0,16.95-3.91,16.95-16.94Zm48.22,44.32v-103a1.23,1.23,0,0,1,1.31-1.3h25a1.19,1.19,0,0,1,1.3,1c0,.52,2.87,15.9,2.87,15.9h.52c6.78-13.81,20.6-18.77,32.59-19.29a1.23,1.23,0,0,1,1.3,1.31V527a1.39,1.39,0,0,1-1.3,1.3h-7c-19.29,0-25.81,7.56-25.81,17.21v57.87a1.39,1.39,0,0,1-1.3,1.3H855.33A1.15,1.15,0,0,1,853.76,603.64Zm-463-51.35c0-33.63,13-54.75,50.31-54.75s50.58,21.38,50.58,54.75c0,33.62-13,54.74-50.58,54.74C403.84,607,390.8,585.91,390.8,552.29Zm32.85,0c0,18.24,2.61,29.19,17.2,29.19,14.86,0,17.47-11.21,17.47-29.19,0-18.25-2.61-29.2-17.47-29.2C426.52,523.09,423.65,534,423.65,552.29Z"
              transform="translate(3.08 -336.64)" fill="#053d4e" />
            <path
              d="M230,541.86c1.56-28.67-8.34-75.6-32.32-114.18a.83.83,0,1,0-1.57.53c1.57,5.73,2.09,16.42-7.3,15.9-16.42-1.05.52-36.5-35.71-60.74a.87.87,0,0,0-1.3,1c2.6,4.69,3.91,19.55-1.83,24.51-4.69,3.91-13,2.86-21.11-10.43-13.56-22.16-8.34-45.62.78-60.48.78-1-.26-1.56-1-1.3-49.79,16.42-59.7,75.07-70.39,96.45-1.82,3.65-3.38,5.47-6.25,5.21-9.13-.52-2.61-20.07.52-26.59.52-1-.52-1.56-1.3-.78C25.6,437.59,2.4,483.21-2,525.44c.26-1.05-.52,3.39-.78,6.77,0,1.31-.26,2.61-.26,3.91v4.7a116.52,116.52,0,1,0,233,2.08Zm-117,54a54,54,0,1,1,54.48-53.44A53.9,53.9,0,0,1,112.93,595.82Z"
              transform="translate(3.08 -336.64)" fill="#f04e23" />
          </svg>
        </div>
        <p class="text1">Entrada com Hotmart</p>
      </div>
      <div class="spaceText2" v-if="integration">
        <p class="text2">
          Parabéns, agora é só copiar a url gerada na integração para utilizar com a hotmart.
        </p>
        <div id="tooltip-token" v-if="integration" class="token-block">
          <span class="url-show text3">
            {{ api_url }}<span v-for="(url, i) in urlparams" :key="i">{{ url }}</span>
          </span>
        </div>
      </div>
      <div class="spaceText2" v-if="!integration">
        <p class="text2">
          Quando estiver pronto para fazer a integração com a Hotmart,
          lembre-se de selecionar cuidadosamente o token e a turma ou assinatura correta para garantir que integração
          funcione corretamente.
        </p>

        <div class="input-group mt-30">
          <select class="form-control select-container" v-model="selectedTokenId">
            <option value="0" selected>Selecione um token...</option>
            <option v-for="token in tokens" :key="token.id" :value="token.id">{{ token.name }}</option>
          </select>
        </div>

        <div class="multi-select-container" v-if="allCourses && selectedTokenId">
          <b class="text3 show-flex">Selecione as Turmas</b>
          <multiselect v-model="selectedCourses" class="multiselect_courses" placeholder="Turmas" selectedLabel=""
            deselectLabel="" tagPlaceholder="" selectLabel="" track-by="id" label="title" :multiple="true"
            :taggable="false" :options="allCourses" />
        </div>
        <div class="multi-select-container" v-if="AllSignatures && selectedTokenId">
          <b class="text3 show-flex">Selecione as Assinaturas</b>
          <multiselect v-model="selectedSignatures" class="multiselect_classes" placeholder="Assinaturas" selectedLabel=""
            deselectLabel="" tagPlaceholder="" selectLabel="" track-by="id" label="title" :multiple="true"
            :taggable="false" :options="AllSignatures" />
        </div>

      </div>

      <div class="spaceBtns">
        <button class="button" v-if="!integration" @click="toCancel">Cancelar</button>
        <button class="button w-100" v-if="integration" @click="toCancel">Fechar</button>
        <button class="button2" v-if="!integration" @click="toIntegration">Gerar entrada</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import courseService from "@/services/resources/CourseService";
import signatureService from "@/services/resources/SignatureService";
const serviceCourse = courseService.build();
const serviceSignature = signatureService.build();


export default {
  props: ['tokens'],
  components: {
    Multiselect
  },
  data() {
    return {
      browserApi: false,
      token: null,
      selectedTokenId: 0,
      selectedCourses: null,
      selectedSignatures: null,
      allCourses: null,
      AllSignatures: null,
      api_url: null,
      integration: null,
      integration_url: null,
      urlparams: []
    }
  },
  methods: {
    copyToken(token) {
      this.browserApi.clipboard.writeText(token);
    },
    toCancel() {
      this.token = null;
      this.selectedCourses = null;
      this.selectedSignatures = null;
      this.api_url = null;
      this.integration = null;
      this.integration_url = null;
      this.selectedTokenId = 0;
      this.$root.$emit('bv::hide::modal', 'modal-integration-hotmart', '#btnShow');
    },
    getCourses() {
      this.loading = true;
      serviceCourse
        .read("/class/all")
        .then((resp) => {
          this.allCourses = resp;
          this.loading = false;
        });
    },
    getSignatures() {
      this.loading = true;
      serviceSignature
        .read("/all")
        .then((resp) => {
          this.AllSignatures = resp;
          this.loading = false;
        });
    },
    toIntegration() {
      this.integration = true;

      if(this.selectedCourses){
        this.selectedCourses.forEach((course) => {
          this.urlparams.push(`&course_class_id[]=${course.id}`);
        });
      }
      if (this.selectedSignatures) {
        this.selectedSignatures.forEach((signature) => {
          this.urlparams.push(`&signature_id[]=${signature.id}`);
        });
      }

    },
    filterToken() {
      const token = this.tokens.filter(token => token.id === this.selectedTokenId);
      this.api_url = `${process.env.VUE_APP_API_HOST}/external/hotmart/student?token=${token[0].token}`;
    },
  },
  watch: {
    selectedTokenId: function () {
      if (this.selectedTokenId) {
        this.filterToken();
        this.urlparams = [];
      }
    },
  },
  mounted() {
    this.getCourses();
    this.getSignatures();
    this.browserApi = navigator;
  }
}
</script>
<style lang="scss">
#modal-integration-hotmart {
  z-index: 99999999999;

  .modal-header {
    border: none;
  }
}

.multiselect {
  -ms-overflow-style: none;
}

.multiselect__tags {
  background: var(--backgroundcolor);
}

.multiselect .multiselect__input,
.multiselect__single {
  background: var(--backgroundcolor);
}

.multiselect__content-wrapper {
  background: var(--backgroundcolor);
}

.multiselect__option--selected {
  background: var(--backgroundcolor);
}
</style>

<style lang="scss" scoped>
.logo {
  height: auto;
  margin-bottom: 40px;
  -webkit-box-align: self-start;
  -ms-flex-align: self-start;
  align-items: self-start;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.url-show {
  word-wrap: break-word;
}

.show-flex {
  display: flex;
}

.logo-svg {
  width: 200px;
}

.multi-select-container {
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
}

.token-block {
  width: 100%;
  height: auto;
  border: 1px solid black;
  border-radius: 12px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 15px;
  overflow-x: hidden;
  overflow-y: hidden;
  margin-bottom: 15px;
}

.select-container option {
  background: var(--backgroundcolor) !important;
  color: var(--fontcolor);
}

#modal-integration-hotmart {
  input {
    border: 1px solid #ededf0;
    box-sizing: border-box;
    border-radius: 5px;
    height: auto;
    font-size: 14px;
    padding: 3px;
    transition: .3s;
  }

  input:hover,
  input:focus {
    border: 1px solid #FC2B36;
    box-shadow: 0px 4px 10px rgba(148, 3, 3, 0.03);
    background: rgba(228, 0, 0, 0.05);
    color: var(--fontcolor);
    font-weight: normal;
  }

  input:focus {
    font-weight: 600;
  }

  .labelxx {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: var(--fontcolor);
    text-align: initial;
  }

  .allContentModal {
    padding: 0px 10px;
    margin: 0 auto;
    display: block;
    text-align: -webkit-center;
    margin-top: -50px;
  }

  .spaceText2 {
    margin-bottom: 20px;
  }

  .spaceText1 {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .text1 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.2px;
    color: #f04e23;
    text-align: left;
    text-align: left;
  }

  .text2 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    text-align: left;
    letter-spacing: 0.2px;
    color: var(--fontcolor);
  }

  .text3 {
    color: var(--fontcolor);
    font-size: 15px;
  }

  .spaceBtns {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .button {
    background: var(--backgroundcolor);
    border-radius: 6px;
    width: 200px;
    height: 45px;
    border-radius: 3px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.2px;
    color: var(--fontcolor);
    border: none;
    margin: 0 5px;
  }

  .button2 {
    background: var(--maincolor);
    border-radius: 6px;
    width: 200px;
    height: 45px;
    border-radius: 3px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.2px;
    color: #FFFFFF;
    border: none;
    margin: 0 5px;
  }
}
</style>